import React from 'react';
import { Database, Snowflake } from 'lucide-react';
import type { ConnectorType } from '../../types';

interface ConnectorOption {
  type: ConnectorType;
  label: string;
  icon: React.ReactNode;
  color: string;
}

const connectors: ConnectorOption[] = [
  {
    type: 'snowflake',
    label: 'Snowflake',
    icon: <Snowflake className="w-8 h-8" />,
    color: 'text-blue-400',
  },
  {
    type: 'postgresql',
    label: 'PostgreSQL',
    icon: <Database className="w-8 h-8" />,
    color: 'text-blue-300',
  },
  {
    type: 'mysql',
    label: 'MySQL',
    icon: <Database className="w-8 h-8" />,
    color: 'text-orange-400',
  },
  {
    type: 'mssql',
    label: 'SQL Server',
    icon: <Database className="w-8 h-8" />,
    color: 'text-red-400',
  },
  {
    type: 'oracle',
    label: 'Oracle',
    icon: <Database className="w-8 h-8" />,
    color: 'text-red-500',
  },
  {
    type: 'redshift',
    label: 'Redshift',
    icon: <Database className="w-8 h-8" />,
    color: 'text-purple-400',
  },
];

interface Props {
  onSelect: (type: ConnectorType) => void;
  selected: ConnectorType | null;
}

const ConnectorGrid: React.FC<Props> = ({ onSelect, selected }) => {
  return (
    <div>
      <h2 className="text-lg font-semibold text-cargo-text mb-4">Choose a data source</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {connectors.map((c) => (
          <button
            key={c.type}
            onClick={() => onSelect(c.type)}
            className={`flex flex-col items-center gap-3 p-6 rounded-xl border-2 transition-all duration-200 ${
              selected === c.type
                ? 'border-cargo-accent bg-cargo-accent/10'
                : 'border-cargo-border bg-cargo-surface hover:border-cargo-hover hover:bg-cargo-panel'
            }`}
          >
            <div className={c.color}>{c.icon}</div>
            <span className="text-sm font-medium text-cargo-text">{c.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConnectorGrid;
